export const moment_getDaysBetweenDates = function(startDate, endDate) {
    let now = startDate.clone(), dates = [];

    while (now.format('YYYY-MM-DD') <= endDate.format('YYYY-MM-DD')) {
        dates.push(now.clone());
        now.add(1, 'days');
    }
    return dates;
};